import axiosClient from "../axiosClient";
import { ref, inject } from "vue";
import { useRouter } from "vue-router";

export default function useAttributeOptions() {
  const attributeOptions = ref({});
  const attributeOption = ref({});
  const validationErrors = ref({});
  const isLoading = ref(false);

  const router = useRouter();
  const swal = inject("$swal");

  const getAttributeOptions = async (
    page = 1,
    search_id = "",
    search_name_en = "",
    search_name_ar = "",
    search_global = "",
    order_column = "created_at",
    order_direction = "desc",
    per_page = 10
  ) => {
    axiosClient
      .get(
        "/attribute-options?" +
          "page=" +
          page +
          "&search_id=" +
          search_id +
          "&search_name_en=" +
          search_name_en +
          "&search_name_ar=" +
          search_name_ar +
          "&search_global=" +
          search_global +
          "&order_column=" +
          order_column +
          "&order_direction=" +
          order_direction +
          "&per_page=" +
          per_page
      )
      .then((response) => {
        attributeOptions.value = response.data;
      })
      .catch((error) => {
        if (error.response?.data) {
          validationErrors.value = error.response.data.errors;

          swal({
            icon: "error",
            title: "Server error, please try again.",
          });
        }
      });
  };

  const getAttributeOption = async (id) => {
    axiosClient.get("/attribute-options/" + id).then((response) => {
      attributeOption.value = response.data.data;
    });
  };

  const storeAttributeOption = async (attributeOption) => {
    if (isLoading.value) return;

    isLoading.value = true;
    validationErrors.value = {};

    let serializedAttributeOption = new FormData();
    for (let item in attributeOption) {
      if (attributeOption.hasOwnProperty(item)) {
        serializedAttributeOption.append(item, attributeOption[item]);
      }
    }

    axiosClient
      .post("/attribute-options", serializedAttributeOption)
      .then((response) => {
        router.push({ name: "attribute-options.index" });
        swal({
          icon: "success",
          title: "attribute option saved successfully",
        });
      })
      .catch((error) => {
        if (error.response.data.errors) {
          validationErrors.value = error.response.data.errors;
        }
      })
      .finally(() => (isLoading.value = false));
  };

  const updateAttributeOption = async (attributeOption) => {
    if (isLoading.value) return;

    isLoading.value = true;
    validationErrors.value = {};

    axiosClient
      .put("/attribute-options/" + attributeOption.id, attributeOption)
      .then((response) => {
        router.push({ name: "attribute-options.index" });
        swal({
          icon: "success",
          title: "Attribute option saved successfully",
        });
      })
      .catch((error) => {
        if (error.response.data.errors) {
          validationErrors.value = error.response.data.errors;
        }
      })
      .finally(() => (isLoading.value = false));
  };

  const deleteAttributeOption = async (id) => {
    swal({
      title: "Are you sure?",
      text: "You won't be able to revert this action!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      confirmButtonColor: "#ef4444",
      timer: 20000,
      timerProgressBar: true,
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        axiosClient
          .delete("/attribute-options/" + id)
          .then((response) => {
            getAttributeOptions();
            router.push({ name: "attribute-options.index" });
            swal({
              icon: "success",
              title: "Attribute option deleted successfully",
            });
          })
          .catch((error) => {
            swal({
              icon: "error",
              title: error,
            });
          });
      }
    });
  };

  return {
    attributeOptions,
    attributeOption,
    getAttributeOptions,
    getAttributeOption,
    storeAttributeOption,
    validationErrors,
    isLoading,
    updateAttributeOption,
    deleteAttributeOption,
  };
}
